import type { ResourceConfig } from "../types";

export const workbenchSiteConfig = {
  displayName: "我的站点",
  category: "workbench-site",
  permissions: {
    "read:all": {
      label: "访问我的站点",
      description: "可以访问站点列表与活动站点（workbench 主干）",
    },
    "write:own": {
      label: "管理自己的站点",
      description: "可以创建/编辑/切换/删除自己的站点",
    },
  },
} satisfies ResourceConfig;
